var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("Input fields cannot be empty. Please fill them")])}
var staticRenderFns = []

export { render, staticRenderFns }